module.exports = __webpack_public_path__ + "static/media/home-2.f8345739.png";